type GroupNode = {
  id: string;
  parentId: string | null;
  name: string;
  sortOrder: number;
  scope: string;
  isDefault: boolean;
};

export function orderAttachGroups<T extends GroupNode>(groups: T[]): T[] {
  const rank = (group: T) => group.isDefault ? 0 : group.scope === "org" ? 1 : group.scope === "division" ? 2 : 3;
  const sorted = [...groups].sort((a, b) => rank(a) - rank(b) || a.sortOrder - b.sortOrder);
  const children = new Map<string, T[]>();
  for (const group of sorted) {
    if (group.parentId) {
      const rows = children.get(group.parentId) ?? [];
      rows.push(group);
      children.set(group.parentId, rows);
    }
  }
  return sorted.filter(group => !group.parentId).flatMap(group => [group, ...(children.get(group.id) ?? [])]);
}

export function attachGroupPath(group: Pick<GroupNode, "name" | "parentId">, groups: Array<Pick<GroupNode, "id" | "name">>) {
  const parent = groups.find(item => item.id === group.parentId);
  return parent ? `${parent.name} / ${group.name}` : group.name;
}
